import React, { useState, useEffect, useRef } from 'react'
import { AddEmail, AddPhoneNumber, ChangePassword, ChangePhoneNumber, DeletePhoneNumber, GetSettingData, isValidate, RemoveEmail, UpdateEmailAlert, UpdateSMSAlert } from '../components/services/api';
import { useNavigate } from 'react-router-dom';

export default function Settings() {
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [emailloading, setEmailLoading] = useState(false);
  const [smsLoading, setSmsLoading] = useState(false);

  const [messageType, setMessageType] = useState('');
  const [message, setMessage] = useState('');
  const [numMessage, setNumMessage] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [numChangeMsg, setNumChangeMsg] = useState('');

  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [repeatNewPass, setRepeatNewPass] = useState('');
  const [passMessage, setPassMessage] = useState('');

  const [changeNumber, setChangeNumber] = useState('');

  const [smsAlert, setSmsAlert] = useState();
  const [EmailAlert, setEmailAlert] = useState();
  const [settings, setSettings] = useState({});
  const navigate = useNavigate();
  const ranOnce = useRef(false);
  const numberRegex = /^(\+1\s?)?(\(?[2-9][0-9]{2}\)?)[\s\-]?[2-9][0-9]{2}[\s\-]?[0-9]{4}$/;

  useEffect(() => {
    if (ranOnce.current) return;
    ranOnce.current = true;
    const checkValidation = async () => {
      try {
        const result = await isValidate();
        if (result.d === true) {
          await getSettingsData();
        }
        else {
          if (result.d === false) {
            navigate("/");
          }
          else {
            navigate("/");
          }
        }
      }
      catch (error) {
        console.log('validation error');
        navigate("/");
      }
    };
    checkValidation();
  }, []);

  const getSettingsData = async () => {
    try {
      const response = await GetSettingData();
      //const responseString = response.d;
      if (response && response.d) {
        console.log()
        setSettings(response.d);
        setEmailAlert(response.d.dropEmail);
        setSmsAlert(response.d.SMS);
      }
      else {
        console.log("Failed to fetch settings data");
        setMessage('Failed to load settings');
      }
    } catch (error) {
      console.error("Error fetching settings data:", error);
      setMessage('Error: ' + (error.message || 'Failed to load settings'));
    }
  };

  // Clear numeric messages after display (auto-dismiss)
  useEffect(() => {
    const any = message || numMessage || alertMessage || passMessage || numChangeMsg
    if (!any) return;
    const timer = setTimeout(() => {
      setMessage('');
      setNumMessage('');
      setAlertMessage('');
      setPassMessage('');
      setNumChangeMsg('')
      setMessageType('');
    }, 5000); // clear after 3 seconds
    return () => clearTimeout(timer);
  }, [message, numMessage, alertMessage, passMessage, numChangeMsg]);

  const handleAddEmail = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');
    try {
      const response = await AddEmail(email);
      const responseStr = JSON.parse(response.d);

      if (responseStr.messsage === 'Email Successfully Added.') {
        setMessageType('success');
        setMessage('Email added successfully');
        await getSettingsData();
        setEmail('');
      }
      else if (responseStr.messsage === 'Duplicate Emails Are Not Allowed.') {
        setMessageType('error');
        setMessage(responseStr.messsage);
        setEmail('');
      } else if (responseStr.messsage === 'Reach Limit') {
        setMessageType('error');
        setMessage('Your Account', responseStr.message);
        setEmail('');
      } else if (responseStr.messsage === 'Insufficient Credits To Add Number Please Upgrade Your Package First.') {
        setMessageType('error');
        setMessage(responseStr.message);
        setEmail('');
      }
      else {
        setMessageType('error');
        setMessage('Failed to add email');
      }
    } catch (error) {
      setMessageType('error');
      setMessage('Failed to add email');
    }
  };

  const deleteEmail = async (emailToDelete) => {
    setMessageType('');
    try {
      const response = await RemoveEmail(emailToDelete);
      if (response && response.d) {
        setMessageType('success');
        setMessage(response.d);
        await getSettingsData();
      }
      else {
        setMessageType('error');
        setMessage('Failed to Delete email');
      }
    } catch (error) {
      setMessageType('error');
      setMessage('Failed to Delete email');
      console.log('error');
    }
  }

  const handleChange = (e) => {
    const value = e.target.value.replace(/[^\d+]/g, '');
    setPhoneNumber(value);
    if (value.length >= 13 && !numberRegex.test(value)) {
      setNumMessage('Invalid number');
    }
    else{
      setNumMessage('');
    }
  }

   const handleChangeNumber = (e) => {
    const value = e.target.value.replace(/[^\d+]/g, '');
    setChangeNumber(value);
    if (value.length >= 13 && !numberRegex.test(value)) {
      setNumChangeMsg('Invalid number');
    }
    else{
      setNumChangeMsg('');
    }
  }

  const handleAddNumber = async (e) => {
    e.preventDefault();
    setNumMessage('');
    setMessageType('');
    if(!numberRegex.test(phoneNumber)) {
      setNumMessage('Enter A Valid Number.')
      return;
    }
    try {
      const response = await AddPhoneNumber(phoneNumber);
      const responseStr_num = JSON.parse(response.d);
      if (responseStr_num.messsage === 'Number Successfully Added.') {
        setMessageType('success')
        setNumMessage(responseStr_num.messsage);
        await getSettingsData();
        setPhoneNumber('');
      } else if (responseStr_num.messsage === 'Number Already Exist.') {
        setMessageType('error');
        setNumMessage(responseStr_num.messsage);
        setPhoneNumber('');
      } else if (responseStr_num.messsage === 'Reach Limit') {
        setMessageType('error');
        setNumMessage('Your Account', responseStr_num.messsage);
        setPhoneNumber('');
      } else if (responseStr_num === 'Insufficient Credits To Add Number Please Upgrade Your Package First.') {
        setMessageType('error');
        setNumMessage(responseStr_num.messsage);
        setPhoneNumber('');
      }
      else {
        setMessageType('error');
        setNumMessage('Failed to add phone number');
      }
    } catch (error) {
      setMessageType('error');
      setNumMessage('Failed to add phone number');
    }
  };

  const deletePhoneNumber = async (numberToDelete) => {
    setMessageType('');
    try {
      const response = await DeletePhoneNumber(numberToDelete);
      if (response && response.d === 'Number Deleted Successfully') {
        setMessageType('success');
        setNumMessage(response.d);
        await getSettingsData();
      }
      else {
        setMessageType('error');
        setNumMessage('Failed to remove phone number');
      }
    } catch (error) {
      setMessageType('error');
      setNumMessage('Failed to remove phone number');
    }
  };

  // Email Alert Toggle Handler
  const EmailAlertToggle = async (e) => {
    const newEmailAlert = e.target.checked;
    setEmailAlert(newEmailAlert);
    setEmailLoading(true);
    setAlertMessage('');
    try {
      const response = await UpdateEmailAlert(newEmailAlert);
      if (response || response.d) {
        setEmailAlert(newEmailAlert);
        await getSettingsData();
        setAlertMessage('Email alert setting updated successfully');
      }
      else {
        setEmailAlert(!newEmailAlert);
        setAlertMessage('Failed to update email alert setting');
      }
    } catch (error) {
      setEmailAlert(!newEmailAlert);
      setAlertMessage('Failed to update email alert setting');
      console.error("Error updating email alert:", error);
    }
    finally { setEmailLoading(false); }
  };

  // SMS Alert Toggle Handler
  const SmsAlertToggle = async (e) => {
    const newSmsAlert = e.target.checked;
    setSmsAlert(newSmsAlert);
    setSmsLoading(true);
    setAlertMessage('');
    try {
      const response = await UpdateSMSAlert(newSmsAlert);
      if (response || response.d) {
        setSmsAlert(newSmsAlert);
        await getSettingsData();
        setAlertMessage('SMS alert setting updated successfully');
      }
    } catch (error) {
      setSmsAlert(!newSmsAlert);
      setAlertMessage('Failed to update SMS alert setting');
      console.error("Error updating SMS alert:", error);
    }
    finally { setSmsLoading(false); }
  };

  // change phone number
  const changePhoneNumber = async (e) => {
    e.preventDefault();
    setNumChangeMsg('');
    setMessageType('');
    //const newNumber = e.target.phone_number.value.trim();
    try {
      const response = await ChangePhoneNumber(changeNumber);
      if (response || response.d) {
        setNumChangeMsg('Phone number updated successfully');
        setMessageType('success');
        await getSettingsData();
        setChangeNumber('');
      }
    } catch (error) {
      setMessageType('error');
      setNumChangeMsg('Enter a Valid Phone Number');
      setChangeNumber('');

    }
  }

  // change password
  const changePassword = async (e) => {
    e.preventDefault();
    setPassMessage('');
    setMessageType('');
    if (!currentPass || !newPass || !repeatNewPass) {
      setPassMessage('All fields are required');
      setMessageType('error');
      return;
    }
    if (newPass !== repeatNewPass) {
      setPassMessage('New password do not match');
      setMessageType('error');
      return;
    }
    try {
      const response = await ChangePassword(currentPass, newPass);
      if (response && response.d === "Password Updated") {
        setPassMessage('Password Changed Successfully.');
        setMessageType('success');
        setCurrentPass('');
        setNewPass('');
        setRepeatNewPass('');
      }
      else {
        setMessageType('error');
        setPassMessage('Failed to change password. Please check your current password.');
      }
    } catch (error) {
      setMessageType('error');
      setPassMessage('Failed to change password. Please check your current password.');
    }
  };

  return (
    <main className='main-container'>
      <div className='container mt-4'>
        {/* <div className=' mb-3'>
          <h5>Settings</h5>
        </div> */}

        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active" id="general-tab" data-bs-toggle="tab" data-bs-target="#general-tab-pane" type="button" role="tab" aria-controls="general-tab-pane" aria-selected="true">General</button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="alert-tab" data-bs-toggle="tab" data-bs-target="#alert-tab-pane" type="button" role="tab" aria-controls="alert-tab-pane" aria-selected="false">Alert</button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="password-tab" data-bs-toggle="tab" data-bs-target="#password-tab-pane" type="button" role="tab" aria-controls="password-tab-pane" aria-selected="false">Change Password</button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="number-tab" data-bs-toggle="tab" data-bs-target="#number-tab-pane" type="button" role="tab" aria-controls="number-tab-pane" aria-selected="false">Change Phone Number</button>
          </li>

        </ul>
        <div className="tab-content" id="myTabContent">
          <div className="tab-pane fade show active" id="general-tab-pane" role="tabpanel" aria-labelledby="general-tab" tabindex="0">
            <div className='row'>
              <div className="col-lg-6 col-sm-12 p-2 ">
                <div className='panel-container p-4'>
                  <h5>Multiple Emails</h5>
                  <form onSubmit={handleAddEmail} className='row py-2 gx-2 gy-2'>
                    <div className='col-lg-8 col-md-7 col-12'>
                      <input type="email" placeholder='Enter Email' className='form-control my-input' value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>
                    <div className='col-lg-4 col-md-5 col-12'>
                      <button className='btn btn-custom' type="Submit">Add Email</button>
                    </div>
                    {message && <p className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}>{message}</p>}
                  </form>
                  <table className='table mt-2'>
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Email</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {settings?.Emails?.map((email, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{email}</td>
                          <td>
                            <button className='btn btn-danger btn-sm' onClick={() => deleteEmail(email)}>Delete</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="col-lg-6 col-sm-12 p-2 ">
                <div className='panel-container p-4'>
                  <h5>Multiple Numbers</h5>
                  <form onSubmit={handleAddNumber} className='row py-2 gx-2 gy-2'>
                    <div className='col-lg-8 col-md-7 col-12'>
                      <input type="text" placeholder='Enter Number' className='form-control my-input' value={phoneNumber} onChange={handleChange} maxLength={20} required />
                    </div>
                    <div className='col-lg-4 col-md-5 col-12'>
                      <button className='btn btn-custom' type="Submit">Add Number</button>
                    </div>
                    {numMessage && <p className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}>{numMessage}</p>}
                  </form>
                  <table className='table mt-2'>
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Number</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody className='table-group-divider'>
                      {settings?.Phones?.map((number, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{number}</td>
                          <td>
                            <button className='btn btn-danger btn-sm' onClick={() => deletePhoneNumber(number)}>Delete</button>
                          </td>
                        </tr>
                      ))}

                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="alert-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
            <div className='row'>
              <div className="col-sm-12 p-2 ">
                <div className='panel-container p-4'>
                  <h5>Alerts</h5>
                  {alertMessage && <p className='text-success mt-2'>{alertMessage}</p>}
                  <div className='row pt-2 gx-2 gy-2 alert-switches'>
                    <div className="col-lg-6 col-12 form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="switchEmailAlert" checked={EmailAlert} onChange={EmailAlertToggle} />
                      {/* {emailloading && <span className='spinner-border spinner-border-sm text-primary me-2' role="status">Saving</span>} */}
                      <label className="form-check-label" htmlFor='switchEmailAlert'>Drop Email Alert</label>
                      <span className={`switch-status ps-1 ${EmailAlert ? 'text-success' : 'text-danger'}`} style={{ fontWeight: 600 }}>({EmailAlert ? 'ON*' : 'OFF*'})</span>
                    </div>
                    <div className="col-lg-6 col-12 form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" id="switchSmsAlert" checked={smsAlert} onChange={SmsAlertToggle} />

                      <label className="form-check-label" htmlFor='switchSmsAlert'>Drop SMS Alert</label>
                      <span className={`switch-status ps-1 ${smsAlert ? 'text-success' : 'text-danger'}`} style={{ fontWeight: 600 }}>({smsAlert ? 'ON*' : 'OFF*'})</span>
                    </div>
                  </div>
                  <p className='note-text mt-3'>From now you'll be receiving Drops-Info email alert from noreply@ticketsinfo.net in Spam folder,
                    you only have to mark Not Spam to any alert you get, So the next Drop alert will be delivered direct in your Inbox.</p>

                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="password-tab-pane" role="tabpanel" aria-labelledby="password-tab" tabindex="0">
            <div className='row'>
              <div className="col-sm-12 p-2 ">
                <div className='panel-container p-4'>
                  <h5>Password</h5>
                  <form onSubmit={changePassword} className='row pt-2 gx-2 gy-2'>
                    <div className='mb-3'>
                      <label htmlFor="current_pass">Current Password</label>
                      <input type="password" id='current_pass' className='form-control my-input' value={currentPass} onChange={(e) => setCurrentPass(e.target.value)} />
                      <p className='note-text'>Note: For security reasons, your need to enter your current password if you want to make any change to your settings.</p>
                    </div>
                    <div className='mb-3'>
                      <label htmlFor="new_pass">New Password</label>
                      <input type="password" id='new_pass' className='form-control my-input ' value={newPass} onChange={(e) => setNewPass(e.target.value)} />
                    </div>
                    <div className='mb-3'>
                      <label htmlFor="repeat_new_pass">Repeat New Password</label>
                      <input type="password" id='repeat_new_pass' className='form-control my-input' value={repeatNewPass} onChange={(e) => setRepeatNewPass(e.target.value)} />
                      {passMessage && <p className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}>{passMessage}</p>}
                    </div>

                    <div className=''>
                      <button className='btn btn-custom' type="Submit">Change Password</button>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="number-tab-pane" role="tabpanel" aria-labelledby="number-tab" tabindex="0">
            <div className='row'>
              <div className="col-sm-12 p-2 ">
                <div className='panel-container p-4'>
                  <h5>Phone Number</h5>
                  <form onSubmit={changePhoneNumber} className='row pt-2 gx-2 gy-2'>
                    <div className='mb-3'>
                      <label htmlFor="">Current Number</label>
                      <input type="text" className='form-control my-input' disabled value={settings.Number} />
                    </div>
                    <div className='mb-2'>
                      <label htmlFor="phone_number">New Number</label>
                      <input type="text" id='phone_number' className='form-control my-input' value={changeNumber} onChange={handleChangeNumber} required />
                      {numChangeMsg && <p className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}>{numChangeMsg}</p>}
                    </div>
                    <p className='note-text'>Note: Please Enter your phone number with country code.
                      For example: +13098577255 or 13098577255</p>
                    <div className=''>
                      <button className='btn btn-custom' type="Submit">Change Number</button>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

